exports.get = (params) => {
	return params.ssl ? 'https' : 'http';
};
